import { Enchant } from '../Item';

const embellishments = {
  DARKMOON_SIGIL_HUNT: {
    id: 1230076,
    name: 'Darkmoon Sigil: Hunt',
    icon: 'inv_12_profession_inscriptions_darkmoonsigil_bloom',
    effectId: 12693,
  },
} satisfies Record<string, Enchant>;

export default embellishments;
